<section id="achievement">
    <div class="row">
        <div class="title-section">
            <h3></h3>
        </div>
        <div class="body-section">
            <div class="column medium-6">
                <h1 class="f-title">
                    ۳۰۰۰
                </h1>
                <p>میلیارد تومان</p>
                <div style="font-size: 20pt;">
                    سرمایه تحت مدیریت
                </div>
            </div>
            <div class="column medium-6">
                <h1 class="f-title">
                    ۲۰۰،۰۰۰
                </h1>
                <p>سرمایه‌گذار</p>
                <div style="font-size: 20pt;">
                    در صندوق‌های آبان
                </div>
            </div>
        </div>
    </div>
   
</section> 
